import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
//import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import * as XLSX from 'sheetjs-style';


const BatchReport = () => {
    const [batchNumbers, setBatchNumbers] = useState([]);
    const [selectedBatch, setSelectedBatch] = useState('');
    const [batchDetails, setBatchDetails] = useState(null);
    const [candidates, setCandidates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showReport, setShowReport] = useState(false);
    const tableRef = useRef();

    useEffect(() => {
        const fetchBatchNumbers = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/batchno_tab');
                const uniqueBatchNumbers = [...new Set(response.data.map(item => item.batch_no))];
                setBatchNumbers(uniqueBatchNumbers);
            } catch (error) {
                console.error('Error fetching batch numbers:', error);
            }
        };
        fetchBatchNumbers();
    }, []);

    const handleShowReport = async () => {
        if (!selectedBatch) return;
        setIsLoading(true);
        try {
            const encodedBatch = encodeURIComponent(selectedBatch);
            const response = await axios.get(`https://api.eazyworldehsengineering.com/api/candidate_registration/report/batch/${encodedBatch}`);
            setBatchDetails(response.data.batch);
            setCandidates(response.data.candidates);
            setShowReport(true);
        } catch (error) {
            console.error('Error fetching report data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDownloadPDF = () => {
        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'pt',
            format: 'a4'
        });

        const lineSpacing = 20;
        let y = 30;

        // Header Title
        doc.setFontSize(14);
        doc.text("Batch Report", 40, y);
        y += lineSpacing;

        if (batchDetails) {
            // Training Title
            doc.setFontSize(12);
            doc.text(batchDetails.training_title || '', 40, y);
            y += lineSpacing;

            // Date and Batch
            const trainingDate = new Date(batchDetails.training_date).toLocaleDateString();
            doc.text(`Training Date: ${trainingDate}`, 40, y);
            doc.text(`Batch No: ${batchDetails.batch_no}`, 400, y);
            y += lineSpacing;

            // Section Title
            doc.setFontSize(11);
            doc.text("BATCH WISE PERFORMANCE AND GRADING SHEET", 40, y);
            y += lineSpacing;

            // Legend
            doc.setFontSize(9);
            doc.text("SS - Safety Systems, WS - Work Safety, LC - Load Chart, S - Signals, DPOC - Daily/Pre-op Checks, PO - Practical Operation", 40, y);
            y += lineSpacing;
        }

        // Table
        autoTable(doc, {
            html: '#reportTable',
            startY: y,
            styles: {
                fontSize: 6,
                cellPadding: 2,
            },
            headStyles: {
                fillColor: [52, 58, 64],
                textColor: [255, 255, 255],
                halign: 'center',
            },
            bodyStyles: {
                halign: 'center',
            },
        });

        doc.save("BatchReport.pdf");
    };

    // const handleDownloadExcel = () => {
    //     const ws = XLSX.utils.aoa_to_sheet([]);

    //     // ======= TITLE & META =======
    //     ws['A1'] = { v: batchDetails.training_title, s: { font: { bold: true, sz: 14 } } };
    //     ws['A2'] = {
    //         v: `Training Date: ${new Date(batchDetails.training_date).toLocaleDateString()} | Batch No: ${batchDetails.batch_no}`,
    //     };
    //     ws['A3'] = {
    //         v: `SS - Safety Systems, WS - Work Safety, LC - Load Chart, S - Signals, DPOC - Daily/Pre-op Checks, PO - Practical Operation`,
    //     };

    //     // Merge for titles (A1 to T1, etc.)
    //     ws['!merges'] = [
    //         { s: { r: 0, c: 0 }, e: { r: 0, c: 19 } }, // A1:T1
    //         { s: { r: 1, c: 0 }, e: { r: 1, c: 19 } },
    //         { s: { r: 2, c: 0 }, e: { r: 2, c: 19 } },
    //         { s: { r: 4, c: 5 }, e: { r: 4, c: 6 } }, // Written Test
    //         { s: { r: 4, c: 7 }, e: { r: 4, c: 12 } }, // Skill Competency
    //         { s: { r: 4, c: 13 }, e: { r: 4, c: 15 } }, // Observation
    //     ];

    //     // ======= HEADERS =======
    //     const headersRow1 = [
    //         "R.No", "Name", "Designation", "Organization", "Exp",
    //         "Written Test", "", // merge
    //         "Skill Competency", "", "", "", "", "", // merge
    //         "Observation", "", "", // merge
    //         "Overall Perform", "Grade", "Remarks", "On", "By"
    //     ];

    //     const headersRow2 = [
    //         "", "", "", "", "",
    //         "Pre Eva", "Post Eva",
    //         "SS", "WS", "LC", "S", "DPOC", "PO",
    //         "Interaction", "Attentive", "Attitude",
    //         "", "", "", "", ""
    //     ];

    //     XLSX.utils.sheet_add_aoa(ws, [headersRow1, headersRow2], { origin: "A5" });

    //     // ======= BODY =======
    //     const body = candidates.map(cand => [
    //         cand.sr_no,
    //         cand.Name,
    //         cand.designation,
    //         cand.organization,
    //         cand.total_year_exp,
    //         cand.pre_evaluation_test,
    //         cand.post_evaluation_test,
    //         cand.safety_sys,
    //         cand.work_safety,
    //         cand.loadchart_grade,
    //         cand.signals_grade,
    //         cand.pre_operational_grade,
    //         cand.practical_opt_grade,
    //         cand.interaction,
    //         cand.attentive,
    //         cand.attitude,
    //         cand.overal_perform,
    //         cand.final_grade,
    //         `${cand.evaluate_grade_status}-${cand.evaluate_remark}`,
    //         cand.evaluated_date ? new Date(cand.evaluated_date).toLocaleDateString() : '',
    //         cand.evaluated_by,
    //     ]);

    //     XLSX.utils.sheet_add_aoa(ws, body, { origin: -1 });

    //     // ======= FOOTER =======
    //     XLSX.utils.sheet_add_aoa(ws, [["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""]],
    //         { origin: -1 });
    //     XLSX.utils.sheet_add_aoa(ws, [["Coordinated By", "Evaluated By", "Checked By", "Approved By"]],
    //         { origin: -1 });

    //     // ======= STYLE HEADER ROWS (Optional Styling Only if using xlsx-style or Excel supports it) =======
    //     // Note: Basic `xlsx` library doesn't support full styling like cell background colors — for that use `xlsx-style` fork if needed.

    //     // ======= BUILD & DOWNLOAD =======
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Report");
    //     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    //     const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    //     saveAs(blob, "BatchReport.xlsx");
    // };

    const handleDownloadExcel = () => {
        const ws = XLSX.utils.aoa_to_sheet([]);

        // ======= ADD TITLE ROWS WITH sheet_add_aoa (not just ws['A1']) =======
        XLSX.utils.sheet_add_aoa(ws, [
            [batchDetails.training_title],
            [`Training Date: ${new Date(batchDetails.training_date).toLocaleDateString()} | Batch No: ${batchDetails.batch_no}`],
            ["SS - Safety Systems, WS - Work Safety, LC - Load Chart, S - Signals, DPOC - Daily/Pre-op Checks, PO - Practical Operation"]
        ], { origin: "A1" });

        // ======= Merge cells for title rows (A1 to U1) =======
        ws['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 20 } }, // A1:U1
            { s: { r: 1, c: 0 }, e: { r: 1, c: 20 } }, // A2:U2
            { s: { r: 2, c: 0 }, e: { r: 2, c: 20 } }, // A3:U3
            { s: { r: 4, c: 5 }, e: { r: 4, c: 6 } },  // Written Test
            { s: { r: 4, c: 7 }, e: { r: 4, c: 12 } }, // Skill Competency
            { s: { r: 4, c: 13 }, e: { r: 4, c: 15 } },// Observation
        ];

        // ======= HEADERS =======
        const headersRow1 = [
            "R.No", "Name", "Designation", "Organization", "Exp",
            "Written Test", "",
            "Skill Competency", "", "", "", "", "",
            "Observation", "", "",
            "Overall Perform", "Grade", "Remarks", "On", "By"
        ];
        const headersRow2 = [
            "", "", "", "", "",
            "Pre Eva", "Post Eva",
            "SS", "WS", "LC", "S", "DPOC", "PO",
            "Interaction", "Attentive", "Attitude",
            "", "", "", "", ""
        ];

        XLSX.utils.sheet_add_aoa(ws, [headersRow1, headersRow2], { origin: "A5" });

        // ======= STYLE HEADER ROWS =======
        const startRow = 4;
        const endCol = 20; // Fix: style till "By" column (index 20)

        for (let row = startRow; row <= startRow + 1; row++) {
            for (let col = 0; col <= endCol; col++) {
                const cellAddr = XLSX.utils.encode_cell({ r: row, c: col });
                if (ws[cellAddr]) {
                    ws[cellAddr].s = {
                        font: { bold: true, color: { rgb: "FFFFFF" } },
                        alignment: { horizontal: 'center', vertical: 'center' },
                        fill: { fgColor: { rgb: "4F81BD" } },
                        border: {
                            top: { style: 'thin', color: { rgb: "000000" } },
                            bottom: { style: 'thin', color: { rgb: "000000" } },
                            left: { style: 'thin', color: { rgb: "000000" } },
                            right: { style: 'thin', color: { rgb: "000000" } },
                        }
                    };
                }
            }
        }

        // ======= BODY =======
        const body = candidates.map(cand => [
            cand.sr_no,
            cand.Name,
            cand.designation,
            cand.organization,
            cand.total_year_exp,
            cand.pre_evaluation_test,
            cand.post_evaluation_test,
            cand.safety_sys,
            cand.work_safety,
            cand.loadchart_grade,
            cand.signals_grade,
            cand.pre_operational_grade,
            cand.practical_opt_grade,
            cand.interaction,
            cand.attentive,
            cand.attitude,
            cand.overal_perform,
            cand.final_grade,
            `${cand.evaluate_grade_status}-${cand.evaluate_remark}`,
            cand.evaluated_date ? new Date(cand.evaluated_date).toLocaleDateString() : '',
            cand.evaluated_by,
        ]);

        XLSX.utils.sheet_add_aoa(ws, body, { origin: -1 });

        // ======= FOOTER =======
        XLSX.utils.sheet_add_aoa(ws, [["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""]], { origin: -1 });
        XLSX.utils.sheet_add_aoa(ws, [["Coordinated By", "Evaluated By", "Checked By", "Approved By"]], { origin: -1 });

        // ======= BUILD & DOWNLOAD =======
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Report");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "BatchReport.xlsx");
    };



    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>Batch Report</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Batch Report</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="content">
                <div className="container-fluid">
                    <div className="card card-primary card-outline">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label>Select Batch Number</label>
                                    <select
                                        className="form-control"
                                        value={selectedBatch}
                                        onChange={(e) => setSelectedBatch(e.target.value)}
                                    >
                                        <option value="">-- Select Batch No --</option>
                                        {batchNumbers.map((batch, idx) => (
                                            <option key={idx} value={batch}>{batch}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-3 d-flex align-items-end">
                                    <button className="btn btn-primary w-100" onClick={handleShowReport}>
                                        Show Report
                                    </button>
                                </div>
                            </div>

                            {isLoading && <div className="text-center text-muted">Loading report...</div>}

                            {showReport && batchDetails && (
                                <>
                                    <div className="mb-3 text-right">
                                        <button className="btn btn-danger btn-sm mr-2" onClick={handleDownloadPDF}>
                                            <i className="fas fa-file-pdf"></i> PDF
                                        </button>
                                        <button className="btn btn-success btn-sm" onClick={handleDownloadExcel}>
                                            <i className="fas fa-file-excel"></i> Excel
                                        </button>
                                    </div>

                                    <div ref={tableRef}>
                                        <h5 className="text-center font-weight-bold">{batchDetails.training_title}</h5>
                                        <p className="text-center">
                                            Training Date: {new Date(batchDetails.training_date).toLocaleDateString()} | Batch No: {batchDetails.batch_no}
                                        </p>

                                        <p className="text-center">
                                            <strong>SS</strong>-Safety Systems,&nbsp;
                                            <strong>WS</strong>-Work Safety,&nbsp;
                                            <strong>LC</strong>-Load Chart,&nbsp;
                                            <strong>S</strong>-Signals,&nbsp;
                                            <strong>DPOC</strong>-Daily/Pre-op Checks,&nbsp;
                                            <strong>PO</strong>-Practical Operation
                                        </p>

                                        <div className="table-responsive">
                                            <table id="reportTable" className="table table-bordered table-sm table-striped">
                                                <thead className="bg-secondary text-white">
                                                    <tr>
                                                        <th rowSpan="2">R.No</th>
                                                        <th rowSpan="2">Name</th>
                                                        <th rowSpan="2">Designation</th>
                                                        <th rowSpan="2">Organization</th>
                                                        <th rowSpan="2">Exp</th>
                                                        <th colSpan="2">Written Test</th>
                                                        <th colSpan="6">Skill Competency</th>
                                                        <th colSpan="3">Observation</th>
                                                        <th rowSpan="2">Overall Perform</th>
                                                        <th rowSpan="2">Grade</th>
                                                        <th rowSpan="2">Remarks</th>
                                                        <th rowSpan="2">On</th>
                                                        <th rowSpan="2">By</th>
                                                    </tr>
                                                    <tr>
                                                        <th>Pre Eva</th>
                                                        <th>Post Eva</th>
                                                        <th>SS</th>
                                                        <th>WS</th>
                                                        <th>LC</th>
                                                        <th>S</th>
                                                        <th>DPOC</th>
                                                        <th>PO</th>
                                                        <th>Interaction</th>
                                                        <th>Attentive</th>
                                                        <th>Attitude</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {candidates.map((cand, idx) => (
                                                        <tr key={idx}>
                                                            <td>{cand.sr_no}</td>
                                                            <td>{cand.Name}</td>
                                                            <td>{cand.designation}</td>
                                                            <td>{cand.organization}</td>
                                                            <td>{cand.total_year_exp}</td>
                                                            <td>{cand.pre_evaluation_test}</td>
                                                            <td>{cand.post_evaluation_test}</td>
                                                            <td>{cand.safety_sys}</td>
                                                            <td>{cand.work_safety}</td>
                                                            <td>{cand.loadchart_grade}</td>
                                                            <td>{cand.signals_grade}</td>
                                                            <td>{cand.pre_operational_grade}</td>
                                                            <td>{cand.practical_opt_grade}</td>
                                                            <td>{cand.interaction}</td>
                                                            <td>{cand.attentive}</td>
                                                            <td>{cand.attitude}</td>
                                                            <td>{cand.overal_perform}</td>
                                                            <td>{cand.final_grade}</td>
                                                            <td>{cand.evaluate_grade_status}-{cand.evaluate_remark}</td>
                                                            <td>{cand.evaluated_date ? new Date(cand.evaluated_date).toLocaleDateString() : ''}</td>
                                                            <td>{cand.evaluated_by}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        <table className="table table-borderless mt-4">
                                            <tbody>
                                                <tr>
                                                    <td>Coordinated By</td>
                                                    <td>Evaluated By</td>
                                                    <td>Checked By</td>
                                                    <td>Approved By</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BatchReport;
